module.exports = __webpack_public_path__ + "img/about-9.c6656e4c.jpg";